// import * as CryptoJS from 'crypto-js'
import * as openpgp from 'openpgp'

import getImageAspectRatio from './get-image-aspect-ratio'

interface DecryptImageArgs {
  encryptedImage: string
  type: string
  password: string
}

async function decryptImage({
  encryptedImage,
  type,
  password,
}: DecryptImageArgs) {
  try {
    // Convert base64 back to binary
    const binaryEncrypted = Uint8Array.from(atob(encryptedImage), (c) =>
      c.charCodeAt(0),
    )

    const message = await openpgp.readMessage({
      binaryMessage: binaryEncrypted, // Changed from armoredMessage to binaryMessage
    })
    const decrypted = await openpgp.decrypt({
      message,
      passwords: [password],
      format: 'binary',
    })
    // Add this log to see what we're getting
    const binaryData =
      typeof decrypted.data === 'string'
        ? new TextEncoder().encode(decrypted.data)
        : decrypted.data

    // Create blob from the binary data
    const imageBlob = new Blob([binaryData], { type })
    const aspectRatio = await getImageAspectRatio(imageBlob)
    return { url: URL.createObjectURL(imageBlob), aspectRatio }
  } catch (error) {
    console.error('Error decrypting image', error)
    return null
  }
}

export default decryptImage
